import styled from 'styled-components';

const InfoDrawer = styled.section`
  background-color: ${p => p.theme.color.white};
  min-width: 250px;
  width: 25vw;
  max-width: 400px;
  height: 100vh;
  overflow: auto;
  margin-right: ${p => p.isOpen ? 0 : '-400px'};
  transition: margin-right .25s ease-in-out;

  .draw-title {
    height: 60px;
    padding: .7em 1.8em .7em .8em;
    margin: 0;
    border-bottom: 1px solid ${p => p.theme.color.border};
    font-weight: normal;
    box-sizing: border-box;
    position: relative;
  }
  .close-button {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 16px;
    top: 20px;
    padding: 0;    
  }

  .block {
    border-bottom: 1px solid ${p => p.theme.color.border};
  }

  .block-caption {
    font-weight: normal;
    padding: .8em;
    margin: 0;
  }

  .row-with-img {
    display: flex;
    align-items: center;
    padding: .5em .8em;
    box-sizing: border-box;
    min-height: 60px;
    p {
      margin: 0;
    }
  }

  .right-section {
    flex: 1;
  }

  .last-name {
    text-transform: uppercase;
  }

  .img-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    margin-right: .5em;
  }
  .image-with-default-wrapper {
    overflow: initial;
  }

  .title {
    line-height: 1.2em;
  }

  .sub-title {
    margin-top: .2em;
    font-size: .9em;
    color: ${p => p.theme.color.label};
  }
  .like-label {
    color: ${p => p.theme.color.label};
    font-size: 0.9em;
  }

  .special-for-patients {
    padding-top: 0;
    .image-with-default-wrapper {
      overflow: hidden;
    }
    .img-container {
      width: 60px;
      height: 60px;
    }
    .title {
      font-size: 1.5em;
      margin-bottom: .2em;
    }
    .sub-title {
      display: flex;
      justify-content: space-between;
      a {
        font-size: 1.1em;
        color: ${p => p.theme.color.darkSkyBlue};
      }
    }
  }
`;

export default {
  InfoDrawer,
};